import "./contacto.css";
import React, { useState, useEffect } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

function Contacto() {
  const [subject, setSubject] = useState("");
  const [sender, setSender] = useState("");
  const [message, setMessage] = useState("");
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/send-email/`, {
        subject,
        sender,
        message,
      });

      setFeedback("¡Mensaje enviado con éxito!");
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      setFeedback("Hubo un error al enviar tu mensaje. Por favor inténtalo de nuevo");
    } finally {
      setSubject("");
      setSender("");
      setMessage("");
    }
  };

  useEffect(() => {
    if (feedback) {
      const timer = setTimeout(() => {
        setFeedback(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [feedback]);

  return (
    <div className="contact-container">
      <h1 className="contact-title">¿Sugerencias o dudas? ¡Contáctanos!</h1>
      <p className="contact-subtitle">Estamos aquí para ayudarte</p>
      
      {feedback && (
        <div
          className={`feedback-container ${
            feedback.includes("éxito") ? "success" : "error"
          }`}
        >
          <p>{feedback}</p>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Título del mensaje"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Tu correo electrónico"
          value={sender}
          onChange={(e) => setSender(e.target.value)}
          required
        />
        <textarea
          placeholder="Escribe aquí tu mensaje"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>
        <button type="submit">Enviar mensaje</button>
        <div className="privacy-notice">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1.33334L2 3.33334V7.33334C2 11.0133 4.53333 14.3467 8 15.3333C11.4667 14.3467 14 11.0133 14 7.33334V3.33334L8 1.33334ZM8 7.99334H12C11.7267 10.78 10.1467 13.26 8 14.1467V8H4V4.06001L8 2.66667V7.99334Z" fill="#666666"/>
          </svg>
          <span>Tus datos estarán seguros con nosotros. Solo usaremos tu correo para responderte.</span>
        </div>
      </form>
    </div>
  );
}

export default Contacto;
